import axios from 'axios'
import { environment } from '@/data/environment/'

const getUserData = () => {
  return JSON.parse(atob(localStorage.getItem('uid')))
}

const isGeneralAdmin = () => {
  const roles = JSON.parse(localStorage.getItem('role') || '[]')
  return roles.includes('General-Admin') || roles.includes('General')
}

export default {
  namespaced: true,
  state: {
    statusGetMandatoryTip: null,
    statusSetMandatoryTip: null,
    mandatoryTip: [],
    mandatoryTipConfigMessage: '',
    listClients: [],
  },
  mutations: {
    setListClients (state, data) {
      state.listClients = data
    },
    setMandatoryTip (state, data) {
      state.mandatoryTip = data
    },
    setResponseUpdateMandatoryTipConfig (state, data) {
      state.statusSetMandatoryTip = data
    },
    setResponseGetMandatoryTip (state, data) {
      state.statusGetMandatoryTip = data
    },
    setResponseMandatoryTipMsg (state, data) {
      state.mandatoryTipConfigMessage = data
    },
  },
  actions: {
    getListClients ({ commit }) {
      const endpoint = '/getClients'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListClients', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    getMandatoryTip ({ commit }, data) {
      const userData = getUserData()
      const idCompania = !isGeneralAdmin() ? data.IdCompania : userData.idcompania
      const params = 'IdCompania=' + idCompania

      const endpoint = '/getMandatoryTipConfig?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      axios
        .create()
        .get(url)
        .then(response => {
          if (!response.data.respuesta.Error) {
            commit('setMandatoryTip', response.data.respuesta.Datos[0])
            commit('setResponseGetMandatoryTip', false)
            commit('setResponseMandatoryTipMsg', 'Configuración de propina obligatoria consultada exitosamente.')
          } else {
            commit('setResponseGetMandatoryTip', true)
            commit('setResponseMandatoryTipMsg', 'Hubo un error obteniendo la configuración de propina obligatoria. Inténtelo nuevamente.')
          }
        })
        .catch(function (error) {
          commit('setResponseGetMandatoryTip', true)
          commit('setResponseMandatoryTipMsg', 'No pudo obtener configuración de propina obligatoria. Inténtelo nuevamente.')
          console.log(error.message)
        })
    },
    updateMandatoryTipConfig ({ commit }, data) {
      const endpoint = '/updateMandatoryTipConfig'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      const userData = getUserData()
      if (isGeneralAdmin()) {
        data.IdCompania = userData.idcompania
      }

      axios
        .create()
        .put(url, data)
        .then(response => {
          if (!response.data.respuesta.Error) {
            commit('setResponseUpdateMandatoryTipConfig', false)
            commit('setResponseMandatoryTipMsg', 'Configuración de propina obligatoria guardada exitosamente.')
          } else {
            commit('setResponseUpdateMandatoryTipConfig', true)
            commit('setResponseMandatoryTipMsg', 'Hubo un error guardando la configuración de propina obligatoria. Inténtelo nuevamente.')
          }
        })
        .catch(function (error) {
          commit('setResponseUpdateMandatoryTipConfig', true)
          commit('setResponseMandatoryTipMsg', 'No pudo guardar la configuración de propina obligatoria.')
          console.log(error.message)
        })
    },
    setUpdateStatusResponse ({ commit }, data) {
      commit('setResponseUpdateMandatoryTipConfig', data)
    },
    statusGetMandatoryTip ({ commit }, data) {
      commit('setResponseGetMandatoryTip', data)
    },
  },
}
